(ns common.schema.entities.workspace.kyc.templates.templates)

(def legal-entity-template-keys
  #{:kyc-template/legal-entity
    :kyc-template/legal-entity-CWS
    :kyc-template/demo-legal-entity
    :kyc-template/innovestor-cofund-angel-entity
    :kyc-template/innovestor-cofund-angel-target-company
    :kyc-template/lifeline-legal-entity})

(def natural-person-templates-keys
  #{:kyc-template/natural-person
    :kyc-template/natural-person-CWS
    :kyc-template/demo-natural-person
    :kyc-template/innovestor-cofund-angel-individual})

(def tenant-template-keys #{:kyc-template/tenant :kyc-template/demo-tenant})

(def contract-template-keys #{:kyc-template/capman-contract})
